module.exports = __webpack_public_path__ + "static/media/qixingshan_web.0e341a5c.png";